// eslint-disable-next-line import/prefer-default-export
export const CI_DRUGLIKENESS_COMPONENTS = [
  {
    title: '',
    children: [
      'lipinskiComponent.logP',
      'lipinskiComponent.hba',
      'lipinskiComponent.hbd',
      'otherComponents.HEV',
      'otherComponents.NOC',
      'veberComponent.boundCount',
      'veberComponent.psa',
    ],
  },
];
